<div class="ho-header">
  <span>Office name</span>
</div>
<div class="ho-section">
  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Office name
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.name}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Place of incorporation
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{getCountryNameById(headOffice?.incorporationPlace)}}
      </span>
    </div>
  </div>

  <div *ngIf="headOffice?.bin" nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      BIN
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.bin}}
      </span>
    </div>
  </div>

  <div *ngIf="headOffice?.registrationNumber" nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Registration Number
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.registrationNumber}}
      </span>
    </div>
  </div>

  <div *ngIf="headOffice?.taxNumber" nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Tax registration number in the country of incorporation
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.taxNumber}}
      </span>
    </div>
  </div>

  <div *ngIf="headOffice?.registrationDate" nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Date of registration
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.registrationDate | date: 'dd.MM.yyyy'}}
      </span>
    </div>
  </div>

  <div *ngIf="headOffice?.startActivityDate" nz-row class="ho-row">
    <div nz-col nzSpan="11" class="ho-label">
      Date of starting the activities in the Republic of Kazakhstan
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.startActivityDate | date: 'dd.MM.yyyy'}}
      </span>
    </div>
  </div>
</div>

<div class="ho-header">
  <span>Address Details</span>
</div>
<div class="ho-section">
  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      City
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.address?.street}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Postal code
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.address?.postalCode}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Street
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.address?.street}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Building number
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.address?.buildingNumber}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row">
    <div nz-col nzSpan="11" class="ho-label">
      Office/Room number
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.address?.officeRoomNumber}}
      </span>
    </div>
  </div>
</div>

<div class="ho-header">
  <span>Company Details</span>
</div>
<div class="ho-section">
  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      CEO First Name
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.ceoFirstName}}
      </span>
    </div>
  </div>
  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      CEO Patronymic Name
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.ceoMiddleName}}
      </span>
    </div>
  </div>
  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      CEO Last Name
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.ceoLastName}}
      </span>
    </div>
  </div>
  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Please give a brief description of the head company’s business activities
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.businessActivityDescription}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Is a legal entity is an international organization?
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.isInternational ? 'Yes' : 'No'}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Is the Head Office a subject to the supervision of a Financial Services Regulator in the relevant jurisdiction or any other jurisdiction?
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.isSubjectOfSupervision ? 'Yes' : 'No'}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Name of registration authority
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.registrationAuthorityName}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Regime of registration
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.registrationRegime}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Organization legal form
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.orgLegalForm}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Address of registration authority
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.registrationAuthorityAddress}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      The date of filing annual return in home jurisdiction
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{annualReturnFilingText}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Is the Head Office obliged to prepare annual accounts in the home jurisdiction?
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.isObligedToPrepareAnnualAccount ? 'Yes' : 'No'}}
      </span>
    </div>
  </div>

  <div *ngIf="headOffice?.isObligedToPrepareAnnualAccount" nz-row class="ho-row">
    <div nz-col nzSpan="11" class="ho-label">
      Please specify the financial year end of the Head Office
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{financialYearEndText}}
      </span>
    </div>
  </div>
</div>

<div class="ho-header">
  <span>Contribution Details</span>
</div>
<div class="ho-section">
  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Type of share capital
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.shareCapitalType}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row ho-row--dashed">
    <div nz-col nzSpan="11" class="ho-label">
      Share capital currency
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.shareCapitalCurrency}}
      </span>
    </div>
  </div>

  <div nz-row class="ho-row">
    <div nz-col nzSpan="11" class="ho-label">
      Amount of share capital
    </div>
    <div nz-col nzSpan="13">
      <span class="ho-value">
        {{headOffice?.shareCapitalAmount}}
      </span>
    </div>
  </div>
</div>
